export const Account = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Account',
    },
    FinalUrlSuffix: {
      bulkDeleteValueIfEmpty: true,
    },
  },
};
